import { render } from "./WhoWeReHome.vue?vue&type=template&id=46807dd0&scoped=true&lang=en"
import script from "./WhoWeReHome.vue?vue&type=script&lang=js"
export * from "./WhoWeReHome.vue?vue&type=script&lang=js"

import "./WhoWeReHome.vue?vue&type=style&index=0&id=46807dd0&scoped=true&lang=scss"

import exportComponent from "/usr/local/var/www/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46807dd0"]])

export default __exports__